import * as React from 'react';
import styles from './switch.scss';
import { keyCodeTypes } from 'ui/common/key-code-types';

import type { JSX } from "react";

export interface SwitchProps {
  className: string;
  checked: boolean;
  disabled?: boolean;
  label?: string;
  onChange: (enabled: boolean) => void;
  textTooltip: string;
  hideTooltip?: boolean;
}

export interface SwitchState {
  hideTooltip?: boolean;
}

export class Switch extends React.Component<SwitchProps, SwitchState> {
  public static defaultProps: Partial<SwitchProps> = {
    className: ''
  };

  public state: Readonly<SwitchState> = {
    hideTooltip: false
  };

  private onChange = () => {
    this.props.onChange(!this.props.checked);

    this.setState({
      hideTooltip: true
    });
  };

  private onKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.code === keyCodeTypes.Enter || e.code === keyCodeTypes.NumpadEnter) {
      this.onChange();
    }
  };

  private handleOnMouseLeave = () => {
    this.setState({
      hideTooltip: false
    });
  };

  public render(): JSX.Element {
    const { label, checked, disabled, textTooltip } = this.props;
    const { hideTooltip } = this.state;

    const arrow =
      <svg viewBox="0 0 20 20" height="10px" width="12px">
        <path className={styles.switchTooltipArrow} d="M4,0H16L10,6Z" transform="translate(-4)" />
      </svg>;

    const switchElement =
      <span className={`${styles.switch}`} onMouseLeave={this.handleOnMouseLeave}>
        <input
          className="visuallyhidden"
          type="checkbox"
          checked={checked}
          disabled={disabled}
          onChange={this.onChange}
          onKeyDown={this.onKeyDown} />
        <span className={`${styles.slider} slider`} />
      </span>;

    const switchContainer =
      <span className={`${styles.switchTooltipTrigger}`}>
        {!hideTooltip && textTooltip && <div className={`${styles.switchTooltip} infotext`} >{textTooltip}</div>}
        {!hideTooltip && textTooltip && arrow}
        {switchElement}
      </span>;

    return (
      <div className={`${this.props.className} ${styles.switchContainer}`}>
        <label className="switch-label-wrapper">
          {label && <span className={styles.switchLabel}>{label}</span>}
          {switchContainer}
        </label>
      </div>
    );
  }
}
